<infra-charge [ghostMode]="ghostMode" [infraCharge]="reservationDetail?.infraChargeDto"></infra-charge>
<ion-card>
    <ion-card-content [hidden]="remoteRequest">
        <ion-label class="ion-text-center">
            <div class="passWrapper">
                <div *ngIf="reservationDetail?.mediaCode" class="passContainer" mediaTag>
                    <p class="passContainer-title"><span class="ghost-hidden">{{'reservation.pass' | translate}}
                    </span></p>
                    <p class="passContainer-number">{{reservationDetail?.mediaCode}}
                    </p>
                    <p *ngIf="reservationDetail?.mediaAlias" class="passContainer-alias">
                        <span class="ghost-hidden">
                            {{reservationDetail?.mediaAlias}}
                        </span>
                    </p>


                </div>
                <div *ngIf="reservationDetail?.otpCode" class="passContainer" mediaTag>
                    <p class="passContainer-title"><span class="ghost-hidden">{{'otp.code' | translate}}</span></p>
                    <p class="passContainer-number">{{reservationDetail?.otpCode}}</p>
                </div>
                <p>
                <span class="ghost-hidden">
                    {{'reservation.until' | translate:
                    {expirationDate: reservationDetail?.expirationDate | date:'medium'} }}
                </span>
                </p>
            </div>

            <div class="passPrice">
                <p>
                    <span class="ghost-hidden">{{'otp.pricing' | translate}}</span>
                </p>
                <div class="passPrice-price ghost-hidden">
                    <pricing-context-formatter [pricingContext]="reservationDetail?.pricingContext"
                                               class="large-ghost-size">
                    </pricing-context-formatter>
                </div>
            </div>
        </ion-label>
        <ion-button (click)="showRemoteStart()" [hidden]="!canShowRemoteStart"
                    color="secondary"
                    expand="block">
            {{'otp.remoteStart' | translate}}
        </ion-button>
        <p *ngIf="!canShowRemoteStart && reservationDetail?.otpCode"
           class="passWrapper ghost-hidden">{{'otp.manual.start' | translate}}</p>
        <p *ngIf="!canShowRemoteStart && reservationDetail?.mediaCode"
           class="passWrapper ghost-hidden">{{'reservation.manual.start' | translate}}</p>
    </ion-card-content>
    <remote (remoteResponse)="handleRemoteResponse($event)"
            [action]="Action.START"
            [hidden]="!remoteRequest"
            [request]="remoteRequest">
    </remote>
</ion-card>
